// /agent — the agent hand-off, given a page of its own.
//
// This panel used to sit at the bottom of the app list, expanded, on every
// visit: a password-shaped field, three copy buttons, a prompt picker and a red
// "revoke" control, under a grid of apps that most visits came to open. It is a
// SETUP task — done once per machine, then not again for months — and setup
// tasks that render on the home page read as things you're supposed to be doing
// now. So it moved here, and the app list points at it from the "New app" tile
// and the account menu.
//
// One page, one component: `ConnectAgent` still owns the code, the prompts and
// the revoke — this route is only the frame around it. `heading={false}`
// because the page already says what it is.

import { Code, Text } from "@mantine/core";
import { ConnectAgent } from "../../components/ConnectAgent.tsx";
import { c } from "../../design/tokens.ts";

export function AgentAccess() {
	return (
		<div
			style={{
				maxWidth: 820,
				margin: "0 auto",
				padding: "clamp(20px, 4vw, 36px) clamp(14px, 3vw, 32px) 72px",
			}}
		>
			<div style={{ marginBottom: 24 }}>
				<h1
					style={{
						margin: "0 0 6px",
						fontSize: 30,
						fontWeight: 800,
						letterSpacing: "-0.03em",
					}}
				>
					Connect an agent
				</h1>
				<Text size="sm" c={c.muted}>
					Hand your agent code to an AI agent (or any headless tool) and it can
					create projects and deploy as you — no browser, no password. Drop it
					into a <Code>.env</Code> as <Code>S3P_AGENT_CODE</Code> and run{" "}
					<Code>s3p login</Code>. Set up once per machine; revoke it here if it
					ever leaks.
				</Text>
			</div>

			<ConnectAgent heading={false} />
		</div>
	);
}
